//@ts-nocheck
import clsx from "clsx";
import React, { useEffect, useState } from "react";

function Tabs(props) {
  const { children, active = 0, className, getActive } = props;

  const [view, setView] = useState({ title: "", content: "" });

  const [changeActive, setChangeActive] = useState(active);

  useEffect(() => {
    setChangeActive(active);

  }, [active]);

  useEffect(() => {
    if (children) {
      getView();
    }

  }, [changeActive, active]);

  const Title = (titleProps) => {
    const { children } = titleProps;

    const handleChangeActive = (index) => {
      setChangeActive(index);
      getActive?.(index);
    };

    return children?.length > 1 ? (
      <ul className={clsx("nav nav-tabs", className)} role="tablist">
        {children?.length
          ? children.map((item, index) => {
              if (item) {
                return (
                  <li className="nav-item" role="presentation" key={index}>
                    <div
                      role="tab"
                      tabIndex={-1}
                      id={`tab${index}`}
                      data-bs-toggle="tab"
                      aria-selected="false"
                      onClick={() => handleChangeActive(index)}
                      className={clsx(
                        "nav-link",
                        changeActive === index && "active"
                      )}
                    >
                      {item}
                    </div>
                  </li>
                );
              }
              return "";
            })
          : ""}
      </ul>
    ) : (
      ""
    );
  };

  const Content = (contentProps) => {
    const { children, id = "tab" } = contentProps;

    return (
      <div id={id} className="tab-content">
        {children?.length
          ? children.map((item, index) => {
              if (item) {
                return (
                  <div
                    role="tabpanel"
                    id={`${id}-${index}`}
                    className={clsx(
                      "tab-pane fade",
                      changeActive === index && "show active"
                    )}
                  >
                    {item}
                  </div>
                );
              }
              return "";
            })
          : null}
      </div>
    );
  };

  const getView = () => {
    const obj = { title: "", content: "" };
    if (children) {
      const list = React.Children.toArray(children);
      for (let i in list) {
        obj["title"] = (
          <Title {...list[0]?.props} active={active}>
            {list[0].props?.children}
          </Title>
        );

        obj["content"] = (
          <Content {...list[1]?.props} active={active}>
            {list[1]?.props?.children}
          </Content>
        );
      }
    }
    setView(obj);
  };

  return (
    <React.Fragment>
      {view?.title}
      {view?.content}
    </React.Fragment>
  );
}

// Tabs.Item;
export default Tabs;

